import { jsxs as S, jsx as u, Fragment as W } from "react/jsx-runtime";
import { forwardRef as j, useState as D, useEffect as z } from "react";
import d from "./styles.module.less.js";
import { QuestionType as G } from "@law-connect/types";
import { InlineForm as H } from "../inline-form/index.js";
import E from "./icon/chevron-right.svg.js";
import L from "./icon/tick.svg.js";
import J from "./icon/arrow-right.svg.js";
import { OverviewForm as K } from "../overview-form/index.js";
const X = j(
  (k, M) => {
    var O, U, B;
    const {
      title: w,
      form: p,
      onChange: C,
      onSubmit: Q,
      disabled: v,
      onSubmitLabel: A,
      forceOrder: x = !0,
      inline: P = !0,
      getTranslation: g
    } = k, [b, N] = D([]), [r, q] = D(null), F = b.every((t) => t.complete);
    z(() => {
      const t = p.questions.reduce((e, n) => {
        var c, h;
        if (n.section) {
          const o = n.section.split("/");
          if (o.length > 1) {
            e[o[0]] || (e[o[0]] = {
              id: o[0],
              title: o[0],
              questions: [],
              children: [],
              complete: !1
            });
            const f = e[o[0]], y = (c = f.children) == null ? void 0 : c.find(
              ($) => $.title === o[1]
            );
            y ? y.questions.push(n) : (h = f.children) == null || h.push({
              id: n.section,
              title: o[1],
              questions: [n],
              children: [],
              complete: !1
            });
          } else
            e[o[0]] ? e[o[0]].questions.push(n) : e[o[0]] = {
              id: n.section,
              title: o[0],
              questions: [n],
              children: [],
              complete: !1
            };
        }
        return e;
      }, {}), l = (e, n) => {
        for (const c of n) {
          if (c.id === e)
            return c;
          if (c.type === G.MultiPart) {
            const h = l(e, c.questions);
            if (h)
              return h;
          }
        }
        return null;
      }, a = (e) => e != null && e !== "", m = (e) => {
        if (e.onlyAvailableIf) {
          const n = e.onlyAvailableIf, c = l(
            n.questionId,
            p.questions
          );
          if (c) {
            let h = !1;
            if (Array.isArray(n.answer) ? h = n.answer.includes(
              c.answer
            ) : h = c.answer === n.answer, !h)
              return null;
          }
        }
        return e.answeredAt ? !0 : e.required ? a(e.answer) : e.answer !== void 0;
      };
      let i = !1;
      const s = Object.values(t).map(
        (e) => {
          if (Object.keys(t).indexOf(e.id) > 0 && !i)
            return e.complete = !1, e;
          let c = !1;
          if (e.children && e.children.length > 0) {
            const h = e.children.map((o) => {
              const y = o.questions.map(($) => m($)).filter(
                ($) => $ !== null
              );
              return y.length === 0 || y.every(($) => $ === !0);
            });
            c = h.every((o) => o), e.children = e.children.map((o, f) => (o.complete = h[f], o));
          } else {
            const o = e.questions.map((f) => m(f)).filter(
              (f) => f !== null
            );
            c = o.length === 0 || o.every((f) => f === !0);
          }
          return c ? (e.complete = !0, i = !0) : i = !1, e;
        }
      );
      N(s);
    }, [p.questions]);
    const I = (t) => (l) => {
      l.preventDefault(), v || q(t);
    }, T = (t) => {
      if (!r || v)
        return;
      const l = {
        ...r,
        questions: t
      };
      q(l);
      const a = b.map((i) => {
        var e;
        if (i.id === l.id)
          return l;
        const s = r.id.split("/");
        return s.length > 1 && i.id === s[0] ? {
          ...i,
          children: (e = i.children) == null ? void 0 : e.map((n) => n.id === r.id ? l : n)
        } : i;
      }), m = a.reduce((i, s) => s.children && s.children.length > 0 ? i.concat(
        s.children.reduce(
          (e, n) => e.concat(n.questions),
          []
        )
      ) : i.concat(s.questions), []);
      C && C(m), N(a);
    }, R = (t) => {
      if (!r || v)
        return;
      const l = {
        ...r,
        questions: t,
        complete: !0
      }, a = b.map((i) => {
        var e;
        if (i.id === l.id)
          return l;
        const s = r.id.split("/");
        return s.length > 1 && i.id === s[0] ? {
          ...i,
          children: (e = i.children) == null ? void 0 : e.map((n) => n.id === r.id ? l : n)
        } : i;
      }), m = a.reduce((i, s) => s.children && s.children.length > 0 ? i.concat(
        s.children.reduce(
          (e, n) => e.concat(n.questions),
          []
        )
      ) : i.concat(s.questions), []);
      C && C(m), N(a), console.log(a), q(null);
    }, V = (t) => {
      if (t.preventDefault(), F && !v) {
        const l = b.reduce((a, m) => m.children && m.children.length > 0 ? a.concat(
          m.children.reduce(
            (i, s) => i.concat(s.questions),
            []
          )
        ) : a.concat(m.questions), []);
        Q && Q(l);
      }
    };
    return /* @__PURE__ */ S(
      "div",
      {
        ref: M,
        ...k.props,
        className: `${d.sectionedForm} ${(O = k.props) == null ? void 0 : O.className}`,
        children: [
          r ? null : /* @__PURE__ */ S(W, { children: [
            w ? /* @__PURE__ */ u("div", { className: d.title, children: w }) : null,
            b.map((t, l) => {
              var m, i, s;
              const a = x ? x && (l === 0 || t.complete || l > 0 && b[l - 1].complete) : !0;
              return /* @__PURE__ */ S("div", { className: d.section, children: [
                t.title && /* @__PURE__ */ S(
                  "div",
                  {
                    className: `${d.sectionTitle} ${a ? d.available : ""}`,
                    style: {
                      cursor: !v && t.children && (t.children.length >= 0 && a || a && t.children.length === 0) ? "pointer" : "default"
                    },
                    onClick: !t.children || t.children.length === 0 && a ? I(t) : void 0,
                    children: [
                      /* @__PURE__ */ u("div", { className: d.sectionTitleText, children: g(
                        `intake.${p.source}.section.${t.title}`
                      ) !== `intake.${p.source}.section.${t.title}` ? g(
                        `intake.${p.source}.section.${t.title}`
                      ) : (m = t.title.split(".").pop()) == null ? void 0 : m.replace(/-/g, " ").replace(/\b\w/g, (e) => e.toUpperCase()) }),
                      t.complete ? /* @__PURE__ */ u("div", { className: d.complete, children: /* @__PURE__ */ u(L, {}) }) : null,
                      !t.children || t.children.length === 0 ? /* @__PURE__ */ u("div", { className: d.caret, children: /* @__PURE__ */ u(E, {}) }) : null
                    ]
                  }
                ),
                t.children && ((i = t.children) == null ? void 0 : i.length) > 0 ? /* @__PURE__ */ u("div", { className: d.section, children: (s = t.children) == null ? void 0 : s.map((e, n) => {
                  const c = l === 0 && n === 0 || e.complete || l > 0 && b[l - 1].complete && (n === 0 || n > 0 && t.children && t.children[n - 1].complete);
                  return /* @__PURE__ */ S(
                    "div",
                    {
                      className: `${d.sectionTitle} ${c ? d.available : ""}`,
                      onClick: !v && (!e.children || e.children.length === 0 && c) ? I(e) : void 0,
                      children: [
                        /* @__PURE__ */ u("div", { className: d.sectionTitleText, children: g(
                          `intake.${p.source}.section.${e.title}`
                        ) }),
                        e.complete ? /* @__PURE__ */ u("div", { className: d.complete, children: /* @__PURE__ */ u(L, {}) }) : null,
                        /* @__PURE__ */ u("div", { className: d.caret, children: /* @__PURE__ */ u(E, {}) })
                      ]
                    },
                    n
                  );
                }) }) : null
              ] }, l);
            }),
            /* @__PURE__ */ S(
              "button",
              {
                className: d.submitButton,
                type: "submit",
                onClick: V,
                disabled: !F || v,
                children: [
                  A || g("chat.submit"),
                  /* @__PURE__ */ u(J, {})
                ]
              }
            )
          ] }),
          r ? P ? /* @__PURE__ */ u(
            H,
            {
              form: {
                id: r.id,
                name: g(`intake.${p.source}.section.${r.id}`) !== `intake.${p.source}.section.${r.id}` ? g(`intake.${p.source}.section.${r.id}`) : ((U = r.id.split(".").pop()) == null ? void 0 : U.replace(/-/g, " ").replace(/\b\w/g, (t) => t.toUpperCase())) || "",
                questions: r.questions
              },
              onChange: T,
              onComplete: R,
              onBack: () => q(null),
              language: k.language,
              getTranslation: g
            }
          ) : /* @__PURE__ */ u(
            K,
            {
              form: {
                id: r.id,
                name: g(`intake.${p.source}.section.${r.id}`) !== `intake.${p.source}.section.${r.id}` ? g(`intake.${p.source}.section.${r.id}`) : ((B = r.id.split(".").pop()) == null ? void 0 : B.replace(/-/g, " ").replace(/\b\w/g, (t) => t.toUpperCase())) || "",
                questions: r.questions
              },
              onChange: T,
              onSubmit: R,
              onSubmitLabel: A,
              onSubmitDisabled: v,
              hideFileUpload: !0,
              hideConditionalQuestions: !0,
              disabled: v,
              onFileUpload: () => {
              },
              onFileRemove: () => {
              },
              language: k.language,
              getTranslation: g
            }
          ) : null
        ]
      }
    );
  }
);
X.displayName = "SectionedForm";
export {
  X as SectionedForm
};
